import { createSlice } from '@reduxjs/toolkit';
import { handleApiCall } from '../../helpers/handleApiCall';
import { commonService } from '../../services/commonServiceInstance';

const initialState = {
    optedOutNumbers: {},
};

const slice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setNotificationInternal(state, action) {
            state.notification = action.payload;
        },
        setOptedOutNumbers(state, action) {
            state.optedOutNumbers = action.payload;
        },
    },
});

export const { setNotificationInternal, setOptedOutNumbers } = slice.actions;
export const notifications = { reducer: slice.reducer, initialState };
export default notifications;

// Thunks (side effects)
export const setNotification = (notification) => (dispatch) => {
    let message, options, errorCode;
    if (typeof notification === 'string' || notification instanceof String) message = notification;
    else ({ message, options, errorCode } = notification);
    // timestamp is used to differentiate between notifications with the same
    // content but are different notifications
    notification = { message, options, errorCode, timestamp: Date.now() };

    dispatch(setNotificationInternal(notification));
};

export const checkForOptOut = (phoneNumber) => async (dispatch, getState) => {
    if (!phoneNumber) return;

    const cacheKey = phoneNumber?.replace(/\D/g, '');
    const { optedOutNumbers } = getState().notifications;

    if (optedOutNumbers[cacheKey]) return optedOutNumbers[cacheKey];

    const { wasSuccessful, isOptedOut } = await handleApiCall(
        async () => await commonService.isPhoneNumberOptedOut({ phoneNumber: cacheKey }),
        {
            dispatch,
        },
    );

    if (!wasSuccessful) return;

    const newOptedOutNumbers = { ...optedOutNumbers, [cacheKey]: isOptedOut };

    await dispatch(setOptedOutNumbers(newOptedOutNumbers));

    return isOptedOut;
};

export const checkForOptOuts = (phoneNumbers) => async (dispatch, getState) => {
    if (!phoneNumbers?.length) return;

    const { optedOutNumbers } = getState().notifications;
    const normalizedPhoneNumbers = phoneNumbers.map((phoneNumber) =>
        phoneNumber?.replace(/\D/g, ''),
    );

    const phoneNumbersToCheck = [];
    const result = {};

    for (const phoneNumber of normalizedPhoneNumbers) {
        if (phoneNumber in optedOutNumbers) {
            result[phoneNumber] = optedOutNumbers[phoneNumber];
        } else {
            phoneNumbersToCheck.push(phoneNumber);
        }
    }

    if (!phoneNumbersToCheck.length) return result;

    const { wasSuccessful, optOutInfo } = await handleApiCall(
        async () =>
            await commonService.arePhoneNumbersOptedOut({ phoneNumbers: phoneNumbersToCheck }),
        {
            dispatch,
            errorMessage: 'SMS opt-out check failed',
        },
    );

    if (!wasSuccessful) return;

    const newOptedOutNumbers = optOutInfo.reduce((acc, { phoneNumber, isOptedOut }) => {
        acc[phoneNumber] = isOptedOut;
        result[phoneNumber] = isOptedOut;
        return acc;
    }, {});

    await dispatch(setOptedOutNumbers({ ...optedOutNumbers, ...newOptedOutNumbers }));

    return result;
};
